import { render, staticRenderFns } from "./CourseGroupEdit.vue?vue&type=template&id=04427a43"
import script from "./CourseGroupEdit.vue?vue&type=script&lang=js"
export * from "./CourseGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports